import React__default from 'react';
import ContentSuggestion from '../ContentSuggestion/ContentSuggestion.js';
import InfinitePagination from '../InfinitePagination/InfinitePagination.js';

const SearchResultsContent = ({ results  })=>{
    const renderPages = ()=>{
        return results.reduce((prev, curr)=>{
            if (curr.link && curr.title) {
                prev.push(/*#__PURE__*/ React__default.createElement("div", {
                    className: "search-results-content__item",
                    key: curr.objectID
                }, /*#__PURE__*/ React__default.createElement(ContentSuggestion, {
                    suggestion: curr
                })));
            }
            return prev;
        }, []);
    };
    if (results.length === 0) return null;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "container search-results-content"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "search-results-content__container"
    }, renderPages()), /*#__PURE__*/ React__default.createElement(InfinitePagination, {
        labelKey: "search.pagingStatus.content"
    }));
};
var SearchResultsContent$1 = SearchResultsContent;

export { SearchResultsContent, SearchResultsContent$1 as default };
//# sourceMappingURL=SearchResultsContent.js.map
